import { useContext, useCallback } from 'react';
import {
  TrackingContext,
  TrackingDispatchEvent,
} from '@/shared/infrastructure/context/TrackingContext';

export const useTracking = () => {
  const { appName, onDispatch } = useContext(TrackingContext);

  const dispatch = useCallback(
    ({ event, interaction = true, ...trackingEvent }: TrackingDispatchEvent) => {
      onDispatch({
        ...trackingEvent,
        event,
        interaction,
        appName,
        timestamp: Date.now(),
      });
    },
    [appName, onDispatch],
  );

  return dispatch;
};
